import produce from "immer"
import type { BundleDetailDto } from "../../models/models"
import type { Bundle } from "../bosatlas/bosatlas.types"
import { BUNDLE_DELETE_COMPLETE, BUNDLE_LOAD, BUNDLE_LOAD_LIST } from "./bundles.actions"
import type { BundleActions, IBundleState } from "./bundles.types"

const bundleInitialState: IBundleState = {}

export function bundleReducer(currentState: IBundleState | undefined, action: BundleActions): IBundleState {
  const state = currentState ?? bundleInitialState
  switch (action.type) {
    case BUNDLE_LOAD_LIST: {
      return replaceBundleList(state, action.payload as Bundle[])
    }
    case BUNDLE_LOAD: {
      return replaceBundle(state, action.payload as BundleDetailDto)
    }
    case BUNDLE_DELETE_COMPLETE: {
      return deleteBundle(state, action.payload as BundleDetailDto)
    }
    default: {
      return state
    }
  }
}

function deleteBundle(currentState: IBundleState, bundle: BundleDetailDto): IBundleState {
  return produce(currentState, (draftState: IBundleState) => {
    draftState.bundleList = currentState.bundleList?.filter((x) => x.id !== bundle.id)
  })
}

function replaceBundle(currentState: IBundleState, bundle: BundleDetailDto): IBundleState {
  return produce(currentState, (draftState: IBundleState) => {
    draftState.bundle = bundle
  })
}

function replaceBundleList(currentState: IBundleState, bundles: Bundle[]): IBundleState {
  return produce(currentState, (draftState: IBundleState) => {
    draftState.bundleList = bundles
  })
}
